module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-latin-ext-500-normal.woff2?9165081d10e1ba60138421473b64c3e3";